import { memo } from 'react'
import { Tabs } from 'components/Tabs/Tabs'
import { Item } from '@react-stately/collections'
import { Doc, MemberProfile } from 'types'
import Styles from './UserProfileTabs.module.scss'
import { ArticleList } from './ArticleList'
import { ProfileInfoTable } from './ProfileInfoTable'

interface Props {
  profile: MemberProfile
  articles: Doc[]
}

const UserProfileTabs = ({ profile, articles = [] }: Props) => (
  <Tabs aria-label="About Profile">
    <Item key="About" title="About">
      <ProfileInfoTable profile={profile} />
    </Item>
    <Item key="Documents" title="Documents">
      <h3 className={Styles.heading}>Recent documents</h3>
      <ArticleList articles={articles} />
    </Item>
  </Tabs>
)

const arePropsEqual = (prevProps: Props, nextProps: Props) => JSON.stringify(prevProps) === JSON.stringify(nextProps)

const MemoizedTabs = memo(UserProfileTabs, arePropsEqual)

export { MemoizedTabs as UserProfileTabs }
